<template>
  <div class="convenience">
    <div class="search-container">
      <el-form ref="form" :model="form" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="手机号" prop="searchValue">
              <el-input clearable placeholder="手机" v-model="form.searchValue1" :maxlength="15"></el-input>
            </el-form-item>
          </el-col>
         <el-col :span="6">
            <el-form-item label="账号" prop="searchValue">
              <el-input clearable placeholder="姓名" v-model="form.searchValue2" :maxlength="15"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="检测仪" prop="types">
               <el-select v-model="form.types" style="width:100%">
                   <el-option v-for="(item) in DetectorList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="text-right">
            <el-button type="primary" @click="searchEvent" class="search-button">{{$t('search')}}</el-button>
            <el-button type="primary" @click="cleanForm" class="clean-button">{{$t('clean')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-container">
      <el-table
        :data="tableData"
        :height="tableHeight"
        style="width: 100%"
        border
        @sort-change="sort_post_change"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          prop="name"
          min-width="168"
          align="center"
		      label="姓名">
        </el-table-column>
        <el-table-column prop="tel"
          align="center"
          min-width="150"
		      label="手机号">
        </el-table-column>
         <el-table-column
          prop="createTime"
          min-width="168"
          align="center"
          label="检测时间"
        ></el-table-column>
        <el-table-column
          prop="detector"
          min-width="168"
          align="center"
          label="检测仪"
        ></el-table-column>
        <el-table-column
          prop="report"
          align="center"
          min-width="150"
          label="报告"
        >
        </el-table-column>
        <el-table-column label="操作" min-width="200" align="center">
          <template slot-scope="scope">
            <span class="oper-text"  @click="changeAddDialog(true, true, scope.row)">打印</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page-content">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="form.pageNum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="form.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="form.total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import mixin from "@/mixins/index";
import apis from "@/apis";
import { mapState } from "vuex";
// import addDialog from "./dialog/addDialog.vue";
// import confirmDialog from "@/components/confirmDialog.vue";
import pageClass from "@/unit/pageClass";
import createDeleteMixin from '@/mixins/createDeleteMixin.js'

class IndexClass extends pageClass {
  constructor(type) {
    super();
    if (type === "form") {
      this.searchValue = ''
    }
  }
}

export default {
  mixins: [mixin, createDeleteMixin(apis.fitnessDeviceManage)],
  data() {
    return {
      DetectorList: [
          {
              label: "检测仪1号",
              value: "1",
          },
          {
              label: "检测仪2号",
              value: "2",
          },
          {
              label: "检测仪3号",
              value: "3",
          },
      ],
      sportsProjectList: [],
      venueName: "",
      form: new IndexClass("form"), // 实例化一个表单的变量
      tableData: [
        {
          name: '张三',
          tel: '12324545762',
          createTime: '2020-11-30 14:00:00',
          detector: '体质检测仪1号',
          report: 0,
        },
        {
          name: 'lisa',
          tel: '18124245762',
          createTime: '2020-11-29 16:00:00',
          detector: '体质检测仪2号',
          report: 0,
        },
        {
          name: '王芳',
          tel: '19024545762',
          createTime: '2020-12-01 09:00:00',
          detector: '体质检测仪3号',
          report: 0,
        },
      ],
      addDialog: {
        visible: false,
        isEdit: false,
      },
      confirmDialog: {
        visible: false,
        type: 1, //1:删除 9：发布
        data: {},
      },
    };
  },
  mounted() {
  },
  activated() {
  },
  computed: {
    ...mapState(["Language", "DROPDOWNBOX", "TOKEN", "venueId"]),
  },
  methods: {
    // 删除
    modelDelete() {
      console.log("this.confirmDialog.data.id", this.confirmDialog.data.id)
      this.$http
        .delete(`${apis.delMontiorDevice}?id=${this.confirmDialog.data.id}`)
        .then((res) => {
          if (res.data.code === 0) {
            this.$refs.confirmDialog.closeDialog();
            this.$message.success("删除成功!");
            this.searchData();
          }
        });
    },
    // 清空按钮
    cleanForm() {
      this.$refs.form.resetFields();
    },
    // 查询
    searchData() {
      const formData = {
        // venueId: this.venueId,
        // deviceType: "2",
        page: this.form.pageNum,
        pageSize: this.form.pageSize,
      }
       this.$http.post(apis.getBodyMonitorList, {
        params: formData,
        }).then((res) => {
        if (res.data.code === 0) {
          console.log("获取体质监测仪数据：", res.data)
          // this.tableData = res.data.data;
          // this.form.total = res.data.data.totalCount  //TODO
        }
      });
    },
    // 修改数据回显
    changeAddDialog(dialogStatus, isEdit = false, data = {}) {
      if (dialogStatus) {
        this.addDialog.isEdit = isEdit;
        if (isEdit) {
          // 调用vuex里面的获取数据的业务，如果要在这里写接口，需要改成Promise
          this.addDialog.data = data;
          // this.$refs["addDialog"].getDataQuery(data);
        }
      } else {
        this.searchData();
      }
      this.$nextTick(() => {
        this.addDialog.visible = dialogStatus;
      });
    },
    /**
     * @function 改变确认/删除弹窗的状态
     * @param {Boolean} dialogStatus 是否展示当前弹窗
     * @param {Number} type 打开的弹窗类型，1为删除确认
     */
    changeConfirmDialog(dialogStatus, type = 1) {
      this.confirmDialog.type = type;
      this.confirmDialog.visible = dialogStatus;
      if (!dialogStatus) {
        this.confirmDialog.data.id = "";
        this.searchEvent();
      }
    },
    /**
     * 删除和发布点击确认
     * id: 对应的id值
     * type 1：删除 9:发布
     */
    /* eslint-disable */
    openDeleteDialog(id, type) {
      this.confirmDialog.type = type;
      this.confirmDialog.data.id = id;
      this.changeConfirmDialog(true, type);
    },
    /**
     * @function 当确认弹窗点击确定的时候触发
     */
    sureConfirmDialog() {
      // 如果一个页面有多个弹窗，视情况决定用if语句还是二元表达式对api进行判断
      if (this.confirmDialog.type === 1) {
        this.modelDelete();
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/styles/mixin.scoped.less";
</style>
<style lang="less" scoped>
@import "~@/assets/styles/mixin.less";
.convenience {
  .search-container {
  .input-wrapper {
    width: 280px;
    position: relative;
    .input-image {
      width: 16px;
      height: 16px;
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
      cursor: pointer;
      }
    }
  }
  .page-content {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 10px 20px;
  }
  .el-tabs__active-bar {
    display: none;
  }
}

.allOff-wrapper{
  display: inline-block;
  margin-right: 38px;
  .allAndOff{
    margin-right: 10px;
  }
}
.btn-wrapper {
  display: inline-block;
  margin-right: 32px;
}
.oper-text{
  color: #439BFF;
  font-size: 12px;
  cursor: pointer;
}
.line{
  display: inline-block;
  margin:0 8px;
  width: 1px;
  height: 13px;
  background: #D8D8D8;
}
.onLine{
  color: #6DD400;
}
.offLine{
  color: #E02020;
}


</style>
